import * as React from 'react';
import {createPortal} from 'react-dom';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';

import css from './custom-accordion.css';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';


interface CustomAccordionProps {
  header: React.ReactNode;
  content: React.ReactNode;
  testId?: string;
}

export const CustomAccordion = ({
  header,
  content,
  testId,
}: CustomAccordionProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [portalStyle, setPortalStyle] = React.useState<React.CSSProperties>({});

  React.useEffect(() => {
    if (isExpanded && headerRef.current) {
      const rect = headerRef.current.getBoundingClientRect();

      setPortalStyle({
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
      });
    }
  }, [isExpanded]);

  return (
    <>
      <div
        ref={headerRef}
        className={css.accordionHeader}
        onClick={() => setIsExpanded((prev) => !prev)}
        data-testid={generateTestId({base: testId, slot: 'accordion-header'})}
      >
        {header}
        <Icon
          name={isExpanded ? 'chevron-up' : 'chevron-down'}
          size="small"
          color="tertiary"
          type="solid"
        />
      </div>

      {isExpanded &&
        createPortal(
          <div
            className={css.accordionPortal}
            style={portalStyle}
            data-testid={generateTestId({
              base: testId,
              slot: 'accordion-portal',
            })}
          >
            {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
            {content}
          </div>,
          document.body,
        )}
    </>
  );
};
